import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Lock } from 'lucide-react';
import { TaraCard, TaraCardContent } from '../components/ui/TaraCard';
import TaraBadge from '../components/ui/TaraBadge';
import BottomNav from '../components/BottomNav';

const domains = [
  {
    id: 'health',
    icon: '❤️',
    name: 'Health & Longevity',
    summary: 'Steady resilience period',
    status: 'calm',
    available: true,
  },
  {
    id: 'career',
    icon: '💼',
    name: 'Career & Success',
    summary: 'Slow growth till 2026',
    status: 'watchful',
    available: false,
  },
  {
    id: 'relationships',
    icon: '💑',
    name: 'Relationships',
    summary: 'Transformative phase ahead',
    status: 'transforming',
    available: false,
  },
  {
    id: 'wealth',
    icon: '💰',
    name: 'Wealth & Finance',
    summary: 'Stable accumulation period',
    status: 'calm',
    available: false,
  },
  {
    id: 'family',
    icon: '👨‍👩‍👧‍👦',
    name: 'Family & Children',
    summary: 'Harmony and growth',
    status: 'calm',
    available: false,
  },
  {
    id: 'education',
    icon: '📚',
    name: 'Education & Skills',
    summary: 'Learning opportunities',
    status: 'calm',
    available: false,
  },
  {
    id: 'spirituality',
    icon: '🕉️',
    name: 'Spirituality',
    summary: 'Deep introspection phase',
    status: 'transforming',
    available: false,
  },
  {
    id: 'travel',
    icon: '✈️',
    name: 'Travel & Settlement',
    summary: 'Movement and change',
    status: 'watchful',
    available: false,
  },
];

const MyDomainsNew = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-stone-50 pb-24">
      {/* Header */}
      <div className="bg-white border-b border-stone-200 px-5 py-4">
        <div className="max-w-2xl mx-auto">
          <h1 className="font-serif text-2xl font-medium text-stone-900">
            My Domains
          </h1>
          <p className="text-sm text-stone-600 mt-1">
            Your life across 8 astrological domains
          </p>
        </div>
      </div>
      
      {/* Domains Grid */}
      <div className="px-5 py-6 max-w-2xl mx-auto space-y-4">
        {domains.map((domain) => (
          <TaraCard 
            key={domain.id} 
            interactive={true}
            onClick={() => navigate(`/domain/${domain.id}`)}
            className=""
          >
            <TaraCardContent className="p-5">
              <div className="flex items-center gap-4">
                <div className="text-4xl">{domain.icon}</div>
                <div className="flex-1">
                  <h3 className="font-serif text-lg font-medium text-stone-900">
                    {domain.name}
                  </h3>
                  <p className="text-sm text-stone-600 mt-1">
                    {domain.summary}
                  </p>
                  <TaraBadge variant={domain.status} size="sm" className="mt-2">
                    {domain.status}
                  </TaraBadge>
                </div>
                <ChevronRight className="w-6 h-6 text-stone-400" />
              </div>
            </TaraCardContent>
          </TaraCard>
        ))}
        
        {/* Coming Soon Note */}
        <TaraCard variant="cosmic" className="text-center p-6">
          <p className="text-sm text-stone-600">
            ✨ More domains launching soon. Health & Longevity is live now.
          </p>
        </TaraCard>
      </div>
      
      <BottomNav active="domains" />
    </div>
  );
};

export default MyDomainsNew;